import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputRadioComponent } from './component/radio/input-radio.component';
import { InputCheckboxComponent } from './component/checkbox/input-checkbox.component';
import { SegmentedControlModule } from '../segmented-control/segmented-control.module';
import { IconComponent } from './component/icon/icon.component';
import { ImageComponent } from './component/image/image.component';
import { SelectableCardsWrapperComponent } from './selectable-card-wrapper.component';
import { SelectableCardsComponent } from './selectable-card.component';
import { ModalModule } from '../modal';
import { LineHeightDirective } from './line-height.directive';
import { MarkdownModule } from 'ngx-markdown';
import { VmSalesCurrencyPipeModule } from './vm-sales-currency.pipe.module';

@NgModule({
  declarations: [
    SelectableCardsWrapperComponent,
    SelectableCardsComponent,
    IconComponent,
    ImageComponent,
    InputRadioComponent,
    InputCheckboxComponent,
    LineHeightDirective,
  ],
  imports: [
    CommonModule,
    SegmentedControlModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    MarkdownModule.forRoot(),
    VmSalesCurrencyPipeModule,
  ],
  exports: [
    SelectableCardsWrapperComponent,
    SelectableCardsComponent,
    IconComponent,
    ImageComponent,
    InputRadioComponent,
    InputCheckboxComponent,
    LineHeightDirective,
  ],
})
export class SelectableCardsModule {}
